import { useQuery } from '@tanstack/react-query';
import { fetchFaqs } from '../../services/faqs';

export const faqsQueryKey = (businessId: string | null) => ['faqs', businessId];

function useGetFaqs(businessId: string | null) {
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: faqsQueryKey(businessId),
    queryFn: () => fetchFaqs(businessId as string),
    enabled: !!businessId,
  });

  return { faqs: data, isLoading, isError, refetch };
}

export default useGetFaqs;
